import React, { useState, useEffect } from "react";
import "./NewClient.css";

const NewClient = ({ goBack, onRegisterSuccess }) => {
  const [formData, setFormData] = useState({
    phone: "",
    name: "",
    age: "",
  });

  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Added loading state
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    let timer;
    if (isSuccess && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [isSuccess, countdown]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      setFormData({ ...formData, phone: value.replace(/\D/g, "").slice(0, 10) });
    } else if (name === "age") {
      setFormData({ ...formData, age: value.replace(/\D/g, "").slice(0, 3) });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Start loading

    try {
      const response = await fetch('/api/db', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'register', data: formData })
      });

      const result = await response.json();

      if (result.error || !response.ok) {
        alert("Registration failed: " + (result.error || "Unknown error"));
        setIsLoading(false); // Stop loading on error
        return;
      }

      setIsLoading(false); // Stop loading on success
      setIsSuccess(true);

      setTimeout(() => {
        goBack();
      }, 5000);
      
    } catch (err) {
      console.error("Registration Error:", err);
      alert("Network error. Please try again.");
      setIsLoading(false); // Stop loading on network failure
    }
  };

  return (
    <div className="new-client-container">
      <div className="new-client-box">
        {isLoading ? (
          /* Using the same spinner structure as LoginForm */
          <div className="loading-box">
            <div className="spinner"></div>
            <p>Registering Patient...</p>
          </div>
        ) : isSuccess ? (
          <div className="success-message">
            <h3>Patient registered successfully!</h3>
            <p>Redirecting to login form in {countdown} seconds...</p>
          </div>
        ) : (
          <>
            <button className="back-btn" onClick={goBack}>←</button>
            <h2>New Client Registration</h2>
            <form onSubmit={handleRegister}>
              <div className="input-group">
                <input type="tel" name="phone" placeholder="Mobile Number" value={formData.phone} onChange={handleChange} maxLength={10} required />
              </div>
              <div className="input-group">
                <input type="text" name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} required />
              </div>
              <div className="input-group">
                <input type="number" name="age" placeholder="Age" value={formData.age} onChange={handleChange} required />
              </div>
              <button type="submit" className="btn-register-submit">Register</button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default NewClient;
